import { useEffect, useState } from 'react';
import axios from 'axios';

export default function RegisterPage() {
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  const redirectToKeycloakRegistration = async () => {
    setError('');
    setLoading(true);
    try {
      const response = await axios.get('/api/auth/oauth/init', {
        params: { register: true }
      });
      const { authUrl } = response.data;
      window.location.href = authUrl;
    } catch (err: unknown) {
      setError(
        axios.isAxiosError<{ message?: string }>(err)
          ? (err.response?.data?.message || 'Failed to redirect to Keycloak registration.')
          : 'Failed to redirect to Keycloak registration.'
      );
      setLoading(false);
      return;
    } finally {
      // Browser redirects before this usually runs; keep fallback state if it does.
    }
  };

  useEffect(() => {
    redirectToKeycloakRegistration();
  }, []);

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2rem' }}>
      <div className="card" style={{ maxWidth: '500px', width: '100%' }}>
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>📝</div>
          <h1 style={{ marginBottom: '0.5rem' }}>Redirecting to Keycloak</h1>
          <p style={{ color: 'var(--gray-600)' }}>
            Registration is handled by Keycloak for a consistent authentication experience.
          </p>
        </div>

        {error && <div className="error" style={{ marginBottom: '1rem' }}>{error}</div>}

        <button
          type="button"
          className="btn btn-primary"
          style={{ width: '100%' }}
          disabled={loading}
          onClick={redirectToKeycloakRegistration}
        >
          {loading ? 'Redirecting...' : 'Continue to Keycloak registration'}
        </button>

        <div style={{ marginTop: '1rem', textAlign: 'center', color: 'var(--gray-600)' }}>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => (window.location.href = '/')}
            disabled={loading}
            style={{ width: '100%' }}
          >
            Return home
          </button>
        </div>
      </div>
    </div>
  );
}
